import type { ReduxApplicationState } from '../combinedReducer';

export const selectAccessibility = (state: ReduxApplicationState) => state.accessibility;

/** Text for the page's visually hidden live region, announcing state changes. */
export const selectPageLiveRegionText = (state: ReduxApplicationState) =>
  state.accessibility.statusMessage;
